var _rect, _rect2, _path, _path2, _path3, _path4, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 37.5,
    width: 9,
    height: 11,
    fill: "#02222B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 37.5,
    width: 9,
    height: 11,
    fill: "#02222B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 23.5C18.1929 23.5 7 34.6929 7 48.5H57C57 34.6929 45.8071 23.5 32 23.5Z",
    fill: "#02222B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27C20.402 27 11 35.9543 11 47H53C53 35.9543 43.598 27 32 27Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7017 29.5254L25.9237 37.6643C25.6582 37.983 25.5255 38.1424 25.5235 38.277C25.5217 38.394 25.5738 38.5053 25.6648 38.5789C25.7694 38.6635 25.9767 38.6635 26.3914 38.6635H31.9407L31.1796 44.7556L37.9576 36.6167C38.2231 36.2979 38.3558 36.1386 38.3578 36.004C38.3596 35.887 38.3075 35.7756 38.2165 35.7021C38.1119 35.6175 37.9046 35.6175 37.4899 35.6175H31.9407L32.7017 29.5254Z",
    fill: "#047290"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2999 29.1892C32.4491 29.0099 32.6987 28.9506 32.9127 29.0434C33.1266 29.1363 33.2537 29.3591 33.2248 29.5906L32.5375 35.0922H37.4918C37.6886 35.0922 37.8727 35.0916 38.0189 35.1049C38.1457 35.1163 38.3416 35.1437 38.5145 35.2675L38.5488 35.2935L38.5882 35.3275C38.7802 35.5018 38.8889 35.751 38.885 36.012C38.8815 36.2442 38.7678 36.4279 38.6907 36.5397C38.6073 36.6605 38.4891 36.8015 38.3631 36.9528L31.5853 45.0918C31.436 45.271 31.1864 45.3304 30.9725 45.2375C30.7585 45.1447 30.6314 44.9218 30.6603 44.6904L31.3476 39.1888H26.3933C26.1965 39.1888 26.0124 39.1893 25.8663 39.1761C25.731 39.1639 25.5171 39.1336 25.3363 38.9874C25.1198 38.8124 24.9959 38.5473 25.0001 38.269L25.0021 38.2261C25.0178 38.0141 25.1221 37.8461 25.1945 37.7413C25.2778 37.6205 25.396 37.4795 25.522 37.3282L32.2999 29.1892ZM26.3293 38.0005C26.2862 38.0522 26.2489 38.0976 26.2162 38.1373C26.2676 38.1376 26.3262 38.1382 26.3933 38.1382H31.9426C32.0932 38.1382 32.2366 38.2029 32.3363 38.3158C32.436 38.4287 32.4825 38.5791 32.4638 38.7286L31.9248 43.042L37.5558 36.2805C37.5989 36.2288 37.636 36.1833 37.6688 36.1435C37.6174 36.1432 37.5589 36.1428 37.4918 36.1428H31.9426C31.7919 36.1428 31.6486 36.0781 31.5488 35.9652C31.4491 35.8522 31.4027 35.7019 31.4213 35.5524L31.9601 31.2388L26.3293 38.0005Z",
    fill: "#047290"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 48.5,
    width: 56,
    height: 10,
    fill: "#02222B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerator);
export default __webpack_public_path__ + "static/media/generator.b7c3614c20c2b265f441e31ed11d1e52.svg";
export { ForwardRef as ReactComponent };